/* eslint-disable react/prop-types */
import React from 'react'
import Grid from '@mui/material/Grid'
import { useOutletContext } from 'react-router-dom'
import GovXLoginForm from '../../../Forms/GovXLoginForm'

export function LoginSection() {
  const { verificationListing } = useOutletContext()

  return (
    <div>
      <Grid container direction="column">
        <Grid item>
          <GovXLoginForm listing={verificationListing} />
        </Grid>
      </Grid>
    </div>
  )
}

export default LoginSection
